define('commons/search-highlight',['jquery'], function($) {
    var DIACRITICS = {
            'a': '[aḀḁĂăÂâǍǎȺⱥȦȧẠạÄäÀàÁáĀāÃãÅåąĄÃąĄ]',
            'b': '[b␢βΒB฿𐌁ᛒ]',
            'c': '[cĆćĈĉČčĊċC̄c̄ÇçḈḉȻȼƇƈɕᴄＣｃ]',
            'd': '[dĎďḊḋḐḑḌḍḒḓḎḏĐđD̦d̦ƉɖƊɗƋƌᵭᶁᶑȡᴅＤｄð]',
            'e': '[eÉéÈèÊêḘḙĚěĔĕẼẽḚḛẺẻĖėËëĒēȨȩĘęᶒɆɇȄȅẾếỀềỄễỂểḜḝḖḗḔḕȆȇẸẹỆệⱸᴇＥｅɘǝƏƐε]',
            'f': '[fƑƒḞḟ]',
            'g': '[gɢ₲ǤǥĜĝĞğĢģƓɠĠġ]',
            'h': '[hĤĥĦħḨḩẖẖḤḥḢḣɦʰǶƕ]',
            'i': '[iÍíÌìĬĭÎîǏǐÏïḮḯĨĩĮįĪīỈỉȈȉȊȋỊịḬḭƗɨɨ̆ᵻᶖİiIıɪＩｉ]',
            'j': '[jȷĴĵɈɉʝɟʲ]',
            'k': '[kƘƙꝀꝁḰḱǨǩḲḳḴḵκϰ₭]',
            'l': '[lŁłĽľĻļĹĺḶḷḸḹḼḽḺḻĿŀȽƚⱠⱡⱢɫɬᶅɭȴʟＬｌ]',
            'n': '[nŃńǸǹŇňÑñṄṅŅņṆṇṊṋṈṉN̈n̈ƝɲȠƞᵰᶇɳȵɴＮｎŊŋ]',
            'o': '[oØøÖöÓóÒòÔôǑǒŐőŎŏȮȯỌọƟɵƠơỎỏŌōÕõǪǫȌȍՕօ]',
            'p': '[pṔṕṖṗⱣᵽƤƥᵱ]',
            'q': '[qꝖꝗʠɊɋꝘꝙq̃]',
            'r': '[rŔŕɌɍŘřŖŗṘṙȐȑȒȓṚṛⱤɽ]',
            's': '[sŚśṠṡṢṣꞨꞩŜŝŠšŞşȘșS̈s̈]',
            't': '[tŤťṪṫŢţṬṭƮʈȚțṰṱṮṯƬƭ]',
            'u': '[uŬŭɄʉỤụÜüÚúÙùÛûǓǔŰűŬŭƯưỦủŪūŨũŲųȔȕ∪]',
            'v': '[vṼṽṾṿƲʋꝞꝟⱱʋ]',
            'w': '[wẂẃẀẁŴŵẄẅẆẇẈẉ]',
            'x': '[xẌẍẊẋχ]',
            'y': '[yÝýỲỳŶŷŸÿỸỹẎẏỴỵɎɏƳƴ]',
            'z': '[zŹźẐẑŽžŻżẒẓẔẕƵƶ]'
        };
    
    var SearchHighlight = function(options) {
        this.options = options;
        
        this.init();
    };
    
    SearchHighlight.prototype.init = function() {
        var self = this;

        $(this.options.input).on('input', function(e) {
            self.search(this.value);
        });
        $(this.options.input).keydown(function(e) {
            if (e.which == 13) {
                e.preventDefault();
                self.next();
            } else if (e.which == 27) {
            	self.clear();
            	if (self.options.onCancel) {
            		self.options.onCancel();
            	}
            }
        });
        if (this.options.next) {
            $(this.options.next).click(function() {
                self.next();
            });
        }
        if (this.options.prev) {
            $(this.options.prev).click(function() {
                self.previous();
            });
        }
    };
    
    var normalize = function(text) {
        var out = text.toLowerCase();
        for (var letter in DIACRITICS) {
            out = out.replace(new RegExp(DIACRITICS[letter], 'g'), letter);
        }
        return out;
    };
    
    SearchHighlight.prototype.search = function(text) {
        var self = this;
        var matches = [];
        var normalizedText = normalize(text);
        
        $(this.options.scope).find(this.options.selector).each(function() {
            var item = normalize($(this).text());
            
            if (item.indexOf(normalizedText) >= 0) {
                self.options.onMatch(this, text, normalizedText);
                
                matches.push(this);
            } else {
                self.options.onNoMatch(this, text, normalizedText);
            }
        });
        
        if (matches != this.matches) {
            this.current = undefined;
            this.matches = matches;
            
            this.next();
        }
    };
    
    SearchHighlight.prototype.next = function() {
        if (this.matches && this.matches.length > 0) {
            this.current = (this.current === undefined ? 0 : (this.current + 1)) % this.matches.length;
            this.options.select(this.matches[this.current]);
        }
    };
    
    SearchHighlight.prototype.previous = function() {
        if (this.matches && this.matches.length > 0) {
            this.current = ((this.current === undefined ? 0 : (this.current - 1)) + this.matches.length) % this.matches.length;
            this.options.select(this.matches[this.current]);
        }
    };
    
    SearchHighlight.prototype.clear = function() {
        this.matches = [];
        this.current = undefined;
        
        var self = this;
        $(this.options.scope).find(this.options.selector).each(function() {
        	self.options.onClear(this);
        });
        
        $(this.options.input).val('');
    }
    
    return SearchHighlight;
});
